import { NgOptimizedImage } from '@angular/common';
import { Component } from '@angular/core';
import { ChatService } from '../chat.service';
import { leftSlideIn } from '@app/animations';
import { NotificationService } from '@app/notification/notification.service';
import { TriviaRainOption } from '@models/trivia.interface';
import { CurrencyComponent } from '@shared/currency/currency.component';
import { IconComponent } from '@shared/icon/icon.component';
import { NamePipe } from '@shared/pipes/name.pipe';

@Component({
  selector: 'app-chat-trivia-rain',
  templateUrl: './chat-trivia-rain.component.html',
  styleUrls: ['./chat-trivia-rain.component.scss'],
  animations: [leftSlideIn(300, '-100%')],
  host: { '[@leftSlideIn]': '' },
  imports: [IconComponent, CurrencyComponent, NgOptimizedImage, NamePipe],
})
export class ChatTriviaRainComponent {
  constructor(public chatService: ChatService, private notificationsService: NotificationService) {}

  async selectOption(option: TriviaRainOption) {
    if (this.chatService.triviaRain.current.options.some((o) => o.selected)) {
      return;
    }

    await this.chatService.answerTriviaRain(option);
    this.notificationsService.success(`Successfully selected '${option.text}'!`, 'Trivia Rain');
    option.selected = true;
  }
}
